import VideoLesson from './VideoLesson'

export default VideoLesson
